let Env = {
  DUTY_CAST_CONTACT_API: undefined,
  DUTY_CAST_API: undefined,
  DUTY_CAST_GOOGLE_ANALYTIC_KEY: undefined,
  DUTY_CAST_GOOGLE_TAG_KEY: undefined,
  DUTY_CAST_TRACKING_URL: undefined,
  DUTY_CAST_FIREBASE_API_KEY: undefined,
  DUTY_CAST_FIREBASE_AUTH_DOMAIN: undefined,
  DUTY_CAST_FIREBASE_DATABASE_URL: undefined,
  DUTY_CAST_FIREBASE_MESSAGING_SENDER_ID: undefined,
  DUTY_CAST_FIREBASE_PROJECT_ID: undefined,
  DUTY_CAST_FIREBASE_STORAGE_BUCKET: undefined,
  DUTY_CAST_BUILD_TIMESTAMP: undefined,
  DUTY_CAST_FLASH_MESSAGE: undefined,
  DUTY_CAST_TRIAL_SURVEY_LINK: undefined,
  DUTY_CAST_STRIPE_API_KEY: undefined,
  DUTY_CAST_UK_FORM_URL: undefined,
  DUTY_CAST_DESTINATION_COUNTRY: undefined,
  DUTY_CAST_EXTENSION_API_BANNER_ON_TOP: undefined,
}

Env = window.env || process.env;

// console.log(Env);

export default Env;